'use strict';

angular.module('webAgro1App').directive('fileInput', function() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function($scope, el, attrs, ngModel) {
      el.bind('change', function(event){
        var files = event.target.files;
        var file = files[0];

        ngModel.$setViewValue(file);
        $scope.$apply();
      });
    }
  };
});
